import { createSelector } from "@reduxjs/toolkit";

export const getPlaces = createSelector(
  (state) => state.place.list,
  (list) => list
)
